import { MapBrowserEvent, Overlay } from 'ol';
import { Coordinate } from 'ol/coordinate';
import ImageLayer from 'ol/layer/Image';
import Layer from 'ol/layer/Layer';
import olMap from 'ol/Map';
import ImageWMS from 'ol/source/ImageWMS';
import { MapHighlightFeatures } from './MapHighlightFeatures';




export class MapFeatureInfo {

    private _overlay: Overlay = null;
    private _popupContainer: JQuery<HTMLElement> = null;
    private _popupContent: JQuery<HTMLElement> = null;
    private _popupCloser: JQuery<HTMLElement> = null;

    public constructor(private _mapHighlightFeatures: MapHighlightFeatures, private _bufferGetFeatureInfo: boolean) {

    }

    public showFeaturesAtEvent = (
        map: olMap,
        evt: MapBrowserEvent,
        callback: Function): void => {
        let self = this;
        let layerNames: Array<string> = [];
        let viewResolution: number = map.getView().getResolution();
        let wmsLayer: ImageLayer;

        map.getLayers().forEach(function (lyr: Layer) {
            //ignore non visible layers & baselayer
            if (lyr instanceof ImageLayer) {
                if (lyr.getVisible() && lyr.getProperties().queryable !== false) {

                    //lyr.getVisible() is returning true for layers that are not currently visible because of min/max resolution settings                
                    let minRes = lyr.getMaxResolution()
                    let maxRes = lyr.getMinResolution()

                    if (minRes > viewResolution && maxRes <= viewResolution) {
                        let sourceParams = (<ImageWMS>lyr.getSource()).getParams();
                        layerNames.push(sourceParams.LAYERS);
                        wmsLayer = lyr;
                    }
                }
            }
        });

        if (layerNames.length > 0) {

            if (this._bufferGetFeatureInfo && viewResolution < 4.804877096575387) {
                //constrain the view resolution to get a bigger bbox on the getFeatureInfo call, i.e. act as a buffer so we can get the prow codes
                //but only do this for users who have premissions
                viewResolution = 4.804877096575387;
            }

            let wmsUrl = (<ImageWMS>wmsLayer.getSource()).getFeatureInfoUrl(
                evt.coordinate,
                viewResolution,
                map.getView().getProjection().getCode(),
                {
                    //'INFO_FORMAT': 'gml'
                    'INFO_FORMAT': 'text/html'
                }
            );

            //https://trailwisetest.esdm.co.uk/wwwroot/mapserver/scripts/mapserv.exe?map=D:\Websites\TrailwiseTest\wwwroot\MapServer\map\trailwise.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&FORMAT=image%2Fpng&TRANSPARENT=true&QUERY_LAYERS=BOATLines&LAYERS=BOATLines&INFO_FORMAT=text%2Fhtml&I=113&J=252&WIDTH=256&HEIGHT=256&CRS=EPSG%3A27700&STYLES=&BBOX=360546.875%2C279296.875%2C365625%2C284375
            //http://stackoverflow.com/questions/5413899/search-and-replace-specific-query-string-parameter-value-in-javascript
            let updateUrlParameter = function (infoUrl, param, value) {
                let regex = new RegExp('(&' + param + '=)[^\&]+');
                return infoUrl.replace(regex, '$1' + value);
            }

            wmsUrl = updateUrlParameter(wmsUrl, "QUERY_LAYERS", layerNames.join());
            wmsUrl = updateUrlParameter(wmsUrl, "LAYERS", layerNames.join());

            $("#mapLoader").show();
            $.get(wmsUrl, function (html) {
                //debugger;
                //let format = new ol.format.WMSGetFeatureInfo();
                //let features = format.readFeatures(html,{ dataProjection: 'EPSG:3857', featureProjection: 'EPSG:3857' });
                //let c = 2;
                self.showPopup(map, html, evt.coordinate);
            }).always(function () {
                $("#mapLoader").hide("slow");
                callback.call(self);
            });
        }
    }

    private showPopup = (map: olMap, html: string, coordinates: Coordinate): void => {
        let self = this;
        let mapDiv = $("#map");

        if (self._popupContainer === null) {
            self._popupContainer = $("<div>", { id: "popup", class: "ol-popup" });
            self._popupCloser = $("<div>", { id: "popup-closer", class: "ol-popup-closer", href: "#" });
            self._popupContent = $("<div>", { id: "popup-content", class: "ol-popup-content" });

            mapDiv.append(self._popupContainer);
            self._popupContainer.append(self._popupCloser);
            self._popupContainer.append(self._popupContent);
            //Add a click handler to hide the popup.
            self._popupCloser.on("click", function () {
                //console.log('close clicked');
                self._overlay.setPosition(undefined);
                self._popupContainer.css("display", "none");
                self._popupCloser.blur();
                self._mapHighlightFeatures.clear();
                return false;
            });

        }
        if (self._overlay === null) {

            self._overlay = new Overlay({
                autoPan: true,
                element: self._popupContainer[0]
            });
            map.addOverlay(self._overlay);
        }

        if (html) {
            self._popupContent.html(html);

            //look for duplicate data-route-id
            let ids = new Array<string>();
            self._popupContent.find("[data-route-id]").each(function (index, element) {
                const id = $(this).data("routeId");

                if (ids.includes(id)) {
                    $(this).css("display", "none");
                } else {
                    ids.push(id);
                }                
            });

            self._popupContainer.css("display", "block");
            if (coordinates) {
                self._overlay.setPosition(coordinates);
            }
        }
    }

}